module.exports = __webpack_public_path__ + "static/media/venus-mars.35e60ea9.svg";